import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChakraProvider, ColorModeScript, extendTheme, } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import { createContext } from 'react';
import { createSemanticTokens } from './theme-config/theme';
import { componentsConfig } from './theme-config/theme-components';
import { casperUITheme } from './theme-config/theme-casper-ui';
import { ThemeColorVariable, } from './theme-types';
export const ThemeProviderContext = createContext({
    colors: casperUITheme.colors,
    fonts: casperUITheme.fonts,
    fontStyleSheet: casperUITheme.fontStyleSheet,
});
/**
 * Provides theme appearance to all children rendered within the provider.
 * Default theme values are set to a Casper UI-theme. To override them,
 * provide your own theme variables.
 */
export function ThemeProvider({ colors = casperUITheme.colors, fonts = casperUITheme.fonts, fontStyleSheet = casperUITheme.fontStyleSheet, children, }) {
    // Create a chakra theme with extended custom configuration
    const config = {
        cssVarPrefix: 'theme',
        initialColorMode: 'light',
        useSystemColorMode: false,
    };
    const theme = extendTheme({
        semanticTokens: createSemanticTokens(colors, fonts),
        components: componentsConfig,
        config,
    });
    return (_jsx(ThemeProviderContext.Provider, { value: { colors, fonts, fontStyleSheet }, children: _jsxs(ChakraProvider, { theme: theme, children: [_jsx(Global, { styles: fontStyleSheet }), _jsx(Global, { styles: `
            body {
              background-color: ${ThemeColorVariable.Background};
              color: ${ThemeColorVariable.OnBackground};
            }
        ` }), children] }) }));
}
/**
 * Custom Casper UI wrapper for Chakra ColorModeScript to handle color mode throughout the app,
 * currently always set to light as initial color mode.
 *
 * @see https://bit.cloud/caspeco/casper-ui-library/base-ui/theme
 */
export function ThemeColorModeScript() {
    // Note: To support "system" color mode in the future we could allow for a prop to be passed in,
    // but it would have to be used in combination with the useSystemColorMode config in the theme.
    // And be well documented + (and probably opt in).
    return _jsx(ColorModeScript, { initialColorMode: "light" });
}
//# sourceMappingURL=theme-provider.js.map